/* eslint-disable @typescript-eslint/no-unused-vars */

import { Modal, Select, Spin } from "antd";
import Styles from "../css/vehicleModals.module.scss";
import { formatAmount } from "utils/currency";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { getUserVehicleDetail } from "store/reducers/vehicle-finance-slice";
import { toast } from "react-toastify";
import { useAppDispatch } from "customHooks/useAppDispatch";
import { useAppSelector } from "customHooks/useAppSelector";
import LoadingCard from "components/shared/LoadingCard/LoadingCard";
import { LoadingOutlined } from "@ant-design/icons";
import { Field, Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import InputField from "components/shared/InputField/InputField";
import HelperText from "components/shared/HelperText/HelperText";
import Button from "components/shared/Button/Button";
import SelectField from "components/shared/SelectField/SelectField";
import Cancel from "../../../../assets/cancel.svg";
import Back from "../../../../assets/back-icon.svg";
import { vehicleMonthlyRepay } from "store/api/vehicle-finance";
const MerchantsVehicleDetailsModal = (props: any) => {
  const {
    loadingApi,
    repaymentResponseData,
    loanAmount,
    checkInspection,
    equityValue,
    vehicleSingleData,
  } = props;
  const { Option } = Select;
  const location = useLocation();
  const [status] = useState("Pending");
  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [amount, setAmount] = useState(0);
  const [hideEquity, setHideEquity] = useState(true);

  const name = useAppSelector((state) => state?.user?.userDetails?.FirstName);
  const searchParams = new URLSearchParams(location.search);
  const paymentCode = searchParams.get("paymentCode");
  // const [isInspectionStatus] = useState("Done");
  const isInspectionStatus = useAppSelector(
    (state) => state?.vehicleFinance?.vehicleInfo?.InspectionStatus
  );
  const [Tenor] = useState([
    { id: 1, name: "12 month", code: "12" },
    { id: 2, name: "24 month", code: "24" },
    { id: 3, name: "36 month", code: "36" },
    { id: 3, name: `48 month`, code: "48" },
  ]);

  const dispatch = useAppDispatch();

  const vehicleData = useAppSelector(
    (state) => state?.vehicleFinance?.vehicleInfo
  );

  const miniEquity = vehicleData?.MinimumEquity;
  const MinimumEquity = Math.ceil(miniEquity * 100) / 100;

  // const [isNew, setIsNew] = useState(vehicleData?.Meta?.CarDetails?.IsNew);

  const VehicleSchema = Yup.object().shape({
    EquityContribution: Yup.string().required(
      "Equity Contribution is required"
    ),
    Tenor: Yup.string().required("Tenor is required"),
  });

  function validateEquity(value: any) {
    const check = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,<>\/?~]/.test(value);
    // const check = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/.test(value);

    let error;
    if (value > vehicleData?.Amount) {
      setHideEquity(true);
      error = "Amount must not exceed  loan amount!";
    }
    if (value < vehicleData?.MinimumEquity) {
      setHideEquity(true);
      error = "Input an amount equal to or above the minimum equity amount!";
    }
    if (check) {
      setHideEquity(true);
      error = "Only numbers are allowed";
    } else {
      setHideEquity(false);
    }

    return error;
  }

  function formatCurrency(amount: number) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "NGN",
    }).format(amount);
  }

  const formattedAmount = formatCurrency(amount);

  const handleKeyDown = (event: any) => {
    const invalidChars = ["-", "e", "+", "E"];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  };

  // useEffect(() => {
  //   if (paymentCode) {
  //     setLoading(true);
  //     dispatch(getUserVehicleDetail({ paymentCode: paymentCode }))
  //       .unwrap()
  //       .then(() => {
  //         setLoading(false);
  //       })
  //       .catch((err: any) => {
  //         toast.error(err);
  //         setLoading(false);
  //       });
  //   }
  // }, [dispatch]);

  return (
    <div>
      <Modal
        title="Basic Modal"
        centered
        destroyOnClose={true}
        width={"80%"}
        open={props.isModalOpen}
        onOk={props.handleOk}
        // onCancel={props.handleCancel}
        className={Styles.customModal}
      >
        <div
          className={Styles.modalContentVerification}
          style={{ paddingTop: "0em" }}
        >
          <div style={{ paddingTop: "1em", cursor: "pointer" }}>
            <img
              onClick={props.goBack}
              src={Back}
              className={Styles.backIcon}
              alt="back"
            />
          </div>
          {loading ? (
            <LoadingCard />
          ) : (
            <div className={Styles.row}>
              <div className={Styles.half} style={{ marginTop: "0em" }}>
                <div className={Styles.carName}>
                  {" "}
                  {vehicleData?.Meta?.CarDetails?.Make}{" "}
                  {vehicleData?.Meta?.CarDetails?.Type} -{" "}
                  {vehicleData?.Meta?.CarDetails?.Year}
                </div>
                <div className={Styles.userName}>
                  Hello {vehicleData?.Name},
                </div>
                <div className={Styles.subDetails}>
                  Your Car Details by {vehicleData?.MerchantName}
                </div>
                <div className={Styles.merchantBox}>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Car Make</div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.Make}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Car Type</div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.Type}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>
                      Year of Manufacture
                    </div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.Year}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Car Color</div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.Color}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Car Rating/Grade</div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.Grade}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>VIN/Chasis number</div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.ChasisNumber}
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Car condition</div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.IsNew
                        ? "New"
                        : "Preowned"}
                    </div>
                  </div>

                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>
                      Car location(state)
                    </div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.Location}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>
                      Car Inspection location
                    </div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.LocationAddress}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>
                      Contact Phone Number
                    </div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {vehicleData?.Meta?.CarDetails?.ContactNumber}
                    </div>
                  </div>
                  <div className={Styles.merchantRow}>
                    <div className={Styles.merchantHalf}>Car Value</div>
                    <div className={Styles.merchantBorderLine} />
                    <div className={Styles.merchantHalfRight}>
                      {formatAmount(vehicleData?.Amount)}
                    </div>
                  </div>
                </div>
              </div>
              <div className={Styles.halfTwo}>
                {/* <div
                  style={{
                    fontWeight: "bold",
                    fontSize: "1.5em",
                    display: isInspectionStatus !== "Done" ? "none" : "",
                  }}
                  className={Styles.subDetails}
                >
                  Equity Contribution
                </div> */}

                {/* {isInspectionStatus !== "Done" && ( */}
                <div>
                  <div className={Styles.loanBlueBox}>
                    <div className={Styles.rowContent}>
                      <div
                        style={{ color: "#32496F" }}
                        className={Styles.descTwo}
                      >
                        Eligible amount
                      </div>
                      <div
                        style={{ fontWeight: "bolder", color: "#003E93" }}
                        className={Styles.descTwo}
                      >
                        {formatAmount(vehicleData?.EligibleAmount)}
                      </div>
                    </div>
                    <div className={Styles.rowContent}>
                      <div
                        style={{ color: "#32496F" }}
                        className={Styles.descTwo}
                      >
                        Loan amount
                      </div>
                      <div
                        style={{ fontWeight: "bolder", color: "#003E93" }}
                        className={Styles.descTwo}
                      >
                        {formatAmount(loanAmount)}
                      </div>
                    </div>
                    <div className={Styles.rowContent}>
                      <div
                        style={{ color: "#32496F" }}
                        className={Styles.descTwo}
                      >
                        Minimum Equity Contribution
                      </div>
                      <div
                        style={{ fontWeight: "bolder", color: "#003E93" }}
                        className={Styles.descTwo}
                      >
                        {formatAmount(MinimumEquity)}
                      </div>
                    </div>
                  </div>

                  <div>
                    <Formik
                      enableReinitialize
                      initialValues={{
                        EquityContribution:
                          vehicleData?.EquityContribution > 0
                            ? vehicleData?.EquityContribution
                            : "",
                        Tenor: vehicleData?.Tenor > 0 ? vehicleData?.Tenor : "",
                      }}
                      validationSchema={VehicleSchema}
                      onSubmit={(values) => {
                        props.savePayment(values);
                      }}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <div className={Styles.top}>
                            <div className={Styles.rowSelect}>
                              <div className={Styles.inputHalfSelect}>
                                <div className={Styles.inputTitle}>
                                  Equity Contribution
                                  <span className={Styles.asteriks}>*</span>
                                </div>

                                <div style={{ position: "relative", width: "100%" }}>
                                  <span
                                    style={{
                                      position: "absolute",
                                      left: "10px",
                                      fontSize: "1rem",
                                      fontWeight: "bold",
                                      color: "gray",
                                      top: "54%", // Adjust for better centering
                                      transform: "translateY(-50%)",
                                      backgroundColor: "white", // Prevents overlap by input
                                      padding: "0 4px", // Adds spacing to avoid text cutting
                                      zIndex: 2, // Ensures it stays above input
                                    }}
                                  >
                                    ₦
                                  </span>
                                  <Field
                                    validate={validateEquity}
                                    component={InputField}
                                    name="EquityContribution"
                                    type="number"
                                    placeholder="Enter amount"
                                    required
                                    // value={vehicleData?.EquityContribution}
                                    onKeyDown={handleKeyDown}
                                    onChange={(event: any) =>
                                      props.onEquityInputChange(event, formik)
                                    }
                                    autoComplete="off"
                                    style={{
                                      paddingLeft: "30px", // Ensures text doesn't overlap ₦
                                      width: "100%",
                                      height: "40px",
                                      position: "relative", // Allows Naira symbol stacking
                                      zIndex: 1, // Ensures input is behind ₦
                                      backgroundColor: "transparent", // Avoids background overlap
                                    }}
                                  />
                                </div>

                                <ErrorMessage name="EquityContribution">
                                  {(msg: string) => (
                                    <HelperText>{msg}</HelperText>
                                  )}
                                </ErrorMessage>
                              </div>

                              {/* {!formik.errors.EquityContribution && */}
                              {/* !hideEquity && ( */}
                              <div className={Styles.inputHalfSelect}>
                                <div className={Styles.inputTitle}>
                                  Select a tenor
                                  <span className={Styles.asteriks}>*</span>
                                </div>
                                <div style={{ marginTop: "0.25em" }}>
                                  <Field
                                    onSelect={props.onSelectChange}
                                    name="Tenor"
                                    component={SelectField}
                                    autoComplete="off"
                                  >
                                    {Tenor.map((prod: any, index: any) => (
                                      <Option
                                        className={Styles.selectOption}
                                        key={index}
                                        value={prod.code}
                                      >
                                        {prod.name}
                                      </Option>
                                    ))}
                                  </Field>
                                </div>
                                <ErrorMessage name="Tenor">
                                  {(msg: string) => (
                                    <HelperText>{msg}</HelperText>
                                  )}
                                </ErrorMessage>
                              </div>
                              {/* )} */}
                            </div>
                          </div>

                          {loadingApi && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                paddingTop: "1em",
                              }}
                            >
                              <Spin
                                indicator={
                                  <LoadingOutlined
                                    style={{ fontSize: 20, color: "black" }}
                                    spin
                                  />
                                }
                              />
                            </div>
                          )}

                          <div>
                            {/* {repaymentResponseData > 0 ||
                              (vehicleData?.EquityContribution &&
                                vehicleData?.Tenor && 
                                ( */}

                            {repaymentResponseData?.ResponseCode === "00" && (
                              // {repaymentResponseData  || (vehicleData?.EquityContribution && vehicleData?.Tenor) && (
                              <div>
                                {/* {!vehicleData?.Meta?.CarDetails?.Make && ( */}
                                <div className={Styles.rowTerms}>
                                  {vehicleData?.Meta?.CarDetails?.IsNew === false && (
                                    <input
                                      type="checkbox"
                                      checked={true}
                                      disabled
                                    />
                                  )}
                                  {vehicleData?.Meta?.CarDetails?.IsNew === true && (
                                    <input
                                      type="checkbox"
                                      checked={checkInspection}
                                      onChange={props.inspectionCheckboxChange}
                                    />
                                  )}
                                  <div className={Styles.terms}>
                                    Check to go for vehicle inspection
                                    Recommended for pre-owned vehicles
                                  </div>
                                </div>
                                {/* )} */}
                                <div className={Styles.rowTerms}>
                                  <span className={Styles.asteriks}>*</span>
                                  <div className={Styles.terms}>
                                    To reduce your loan amount increase your
                                    equity contribution{" "}
                                    <span>
                                      <a href="#">Learn more</a>
                                    </span>
                                  </div>
                                </div>

                                <div className={Styles.rowTerms}>
                                  <span className={Styles.asteriks}>*</span>
                                  <div className={Styles.terms}>
                                    Ensure your account is funded with the
                                    equity contribution amount when booking
                                    loan.{" "}
                                    <span>
                                      <a href="#">Learn more</a>
                                    </span>
                                  </div>
                                </div>

                                <div className={Styles.rowContent}>
                                  <div
                                    style={{ color: "#32496F" }}
                                    className={Styles.descTwo}
                                  >
                                    Total Repayment Amount
                                  </div>
                                  <div
                                    style={{
                                      fontWeight: "bolder",
                                      color: "#003E93",
                                    }}
                                    className={Styles.descTwo}
                                  >
                                    {formatAmount(
                                      repaymentResponseData?.TotalRepayment
                                    )}
                                  </div>
                                </div>
                                <div className={Styles.borderLineThree} />

                                <div className={Styles.rowContent}>
                                  <div
                                    style={{ color: "#32496F" }}
                                    className={Styles.descTwo}
                                  >
                                    Monthly Repayment Amount
                                  </div>
                                  <div
                                    style={{
                                      fontWeight: "bolder",
                                      color: "#003E93",
                                    }}
                                    className={Styles.descTwo}
                                  >
                                    {formatAmount(
                                      repaymentResponseData?.MonthlyRepayment
                                    )}
                                  </div>
                                </div>
                                <div className={Styles.borderLineThree} />

                                <div className={Styles.top}>
                                  <Button
                                    // variant={
                                    //   !(formik.isValid && formik.dirty) &&
                                    //   !loading
                                    //     ? "disabled"
                                    //     : "primary"
                                    // }
                                    variant="primary"
                                    type="submit"
                                    label="Continue"
                                  />
                                </div>
                              </div>
                            )}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </div>
                {/* )} */}

                {/* {isInspectionStatus === "Done" && (
                  <div>
                    <div className={Styles.loanBlueBox}>
                      <div className={Styles.rowContent}>
                        <div
                          style={{ color: "#32496F" }}
                          className={Styles.descTwo}
                        >
                          Minimum Equity Contribution Entered
                        </div>
                        <div
                          style={{ fontWeight: "bolder", color: "#003E93" }}
                          className={Styles.descTwo}
                        >
                          {formatAmount(vehicleData?.MinimumEquity)}
                        </div>
                      </div>

                      <div className={Styles.rowContent}>
                        <div
                          style={{ color: "#32496F" }}
                          className={Styles.descTwo}
                        >
                          Comprehensive Motor Vehicle Insurrance
                        </div>
                        <div
                          style={{ fontWeight: "bolder", color: "#003E93" }}
                          className={Styles.descTwo}
                        >
                          {formatAmount(vehicleData?.vehicleInsurance)}
                        </div>
                      </div>

                      <div className={Styles.rowContent}>
                        <div
                          style={{ color: "#32496F" }}
                          className={Styles.descTwo}
                        >
                          Credit Life Insurance
                        </div>
                        <div
                          style={{ fontWeight: "bolder", color: "#003E93" }}
                          className={Styles.descTwo}
                        >
                          {formatAmount(vehicleData?.CreditLifeInsurance)}
                        </div>
                      </div>
                      <div className={Styles.rowContent}>
                        <div
                          style={{ color: "#32496F" }}
                          className={Styles.descTwo}
                        >
                          Management fee
                        </div>
                        <div
                          style={{ fontWeight: "bolder", color: "#003E93" }}
                          className={Styles.descTwo}
                        >
                          {formatAmount(vehicleData?.ManagementFee)}
                        </div>
                      </div>
                      <div className={Styles.borderLineThree} />
                      <div className={Styles.rowContent}>
                        <div
                          style={{ color: "#32496F" }}
                          className={Styles.descTwo}
                        >
                          Total Upfront Payment
                        </div>
                        <div
                          style={{ fontWeight: "bolder", color: "#003E93" }}
                          className={Styles.descTwo}
                        >
                          {formatAmount(vehicleData?.LoanAmount)}
                        </div>
                      </div>
                    </div>

                    <div>
                      <div
                        className={Styles.terms}
                        style={{ paddingLeft: "0em", paddingTop: "1.5em" }}
                      >
                        Pay for equity contribution via
                      </div>

                      <div className={Styles.rowContent}>
                        <div
                          style={{ display: "flex", alignItems: "center" }}
                          className={Styles.inputHalfSelect}
                        >
                          <input
                            type="radio"
                            checked={isInspection}
                            onChange={props.inspectionCheckboxChange}
                          />
                          <div
                            className={Styles.terms}
                            style={{ paddingLeft: "0.5em" }}
                          >
                            Pay with Access Bank account
                          </div>
                        </div>

                        <div
                          style={{ display: "flex", alignItems: "center" }}
                          className={Styles.inputHalfSelect}
                        >
                          <input
                            type="radio"
                            checked={isInspection}
                            onChange={props.inspectionCheckboxChange}
                          />
                          <div
                            className={Styles.terms}
                            style={{ paddingLeft: "0.5em" }}
                          >
                            Pay with card
                          </div>
                        </div>
                      </div>

                      <div className={Styles.rowTerms}>
                        <span className={Styles.asteriks}>*</span>
                        <div className={Styles.terms}>
                          Ensure your account is funded with the equity
                          contribution amount when booking loan.{" "}
                          <span>
                            <a href="#">Learn more</a>
                          </span>
                        </div>
                      </div>

                      <div className={Styles.rowSelect}>
                        <div className={Styles.inputHalfSelect}>
                          <div className={Styles.inputTitle}>
                            Loan Amount
                            <span className={Styles.asteriks}>*</span>
                          </div>
                          <div className={Styles.disabledInput}>
                            {formatAmount(vehicleData?.LoanAmount)}
                          </div>
                        </div>

                        <div className={Styles.inputHalfSelect}>
                          <div className={Styles.inputTitle}>
                            Tenor
                            <span className={Styles.asteriks}>*</span>
                          </div>
                          <div className={Styles.disabledInput}>
                            {vehicleData?.Tenor} Month
                          </div>
                        </div>
                      </div>
                      <div className={Styles.rowContent}>
                        <div
                          style={{ color: "#32496F" }}
                          className={Styles.descTwo}
                        >
                          Monthly Repayment Amount
                        </div>
                        <div
                          style={{
                            fontWeight: "bolder",
                            color: "#003E93",
                          }}
                          className={Styles.descTwo}
                        >
                          {formatAmount(
                            repaymentResponseData?.MonthlyRepayment
                          )}
                        </div>
                      </div>

                      <div className={Styles.rowTerms}>
                        <input
                          type="checkbox"
                          checked={isInspection}
                          onChange={props.inspectionCheckboxChange}
                        />
                        <div className={Styles.terms}>
                          I agree to <a href=""> inspection report</a>
                        </div>
                      </div>
                      <div
                        style={{ paddingLeft: "0em", paddingTop: "1em" }}
                        className={Styles.terms}
                      >
                        By clicking on proceed,You authorise Access Bank to book
                        a vehicle loan
                      </div>

                      <div className={Styles.rowSelect}>
                        <div className={Styles.inputHalfSelect}>
                          <button className={Styles.btn}>PROCEED</button>
                        </div>

                        <div className={Styles.inputHalfSelect}>
                          <button className={Styles.btnOutline}>CANCEL</button>
                        </div>
                      </div>
                    </div>
                  </div>
                )} */}
              </div>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default MerchantsVehicleDetailsModal;
